var _g, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 155,
    viewBox: "0 0 258 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.10938,
    y: 87.1094,
    width: 198.781,
    height: 65.7812,
    rx: 7.89062,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.10938,
    y: 87.1094,
    width: 198.781,
    height: 65.7812,
    rx: 7.89062,
    stroke: "black",
    strokeWidth: 4.21875
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.486 6C257.486 3.05448 255.098 0.666664 252.152 0.666664C249.207 0.666664 246.819 3.05448 246.819 6C246.819 8.94552 249.207 11.3333 252.152 11.3333C255.098 11.3333 257.486 8.94552 257.486 6ZM206.333 91.4297C206.333 88.4842 203.946 86.0964 201 86.0964C198.054 86.0964 195.667 88.4842 195.667 91.4297C195.667 94.3752 198.054 96.763 201 96.763C203.946 96.763 206.333 94.3752 206.333 91.4297ZM252.152 6H251.152V58.0964H252.152H253.152V6H252.152ZM251.166 59.8821L250.634 59.0355L200.468 90.5832L201 91.4297L201.532 92.2762L251.698 60.7286L251.166 59.8821ZM252.152 58.0964H251.152C251.152 58.4778 250.956 58.8325 250.634 59.0355L251.166 59.8821L251.698 60.7286C252.603 60.1595 253.152 59.1654 253.152 58.0964H252.152Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 91,
    r: 6,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 91,
    r: 5.5,
    fill: "black",
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 91,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 6,
    r: 6,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 6,
    r: 5.5,
    fill: "black",
    stroke: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 6,
    r: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLogo);
export default __webpack_public_path__ + "static/media/pro_logo.91b8d24afab071ec03aabce065067ee6.svg";
export { ForwardRef as ReactComponent };